// Böngésző-oldalak szűrőállapotának memóriában tartott tára (kulcs: az oldal `name` propja).
// Szándékosan NEM local/sessionStorage: oldalon belüli navigáláskor megmarad,
// F5-re (teljes oldal-újratöltésre) elveszik — ez az elvárt viselkedés.
const states = new Map<string, unknown>();

export function saveSearchState(key: string, state: unknown): void {
  states.set(key, state);
}

export function getSearchState<T>(key: string): T | undefined {
  return states.get(key) as T | undefined;
}
